import api from '../../services/api';
import { LOAD_ACTIONS } from '../types/actionTypes';

export const fetchLoad = (loadNumber) => async (dispatch) => {
  dispatch({ type: LOAD_ACTIONS.FETCH_LOAD_REQUEST });
  
  try {
    const response = await api.get(`/inbound/loads/${loadNumber}`);
    console.log('Load fetched:', response.data);
    
    dispatch({
      type: LOAD_ACTIONS.FETCH_LOAD_SUCCESS,
      payload: response.data
    });
    
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to fetch load';
    dispatch({
      type: LOAD_ACTIONS.FETCH_LOAD_FAILURE,
      payload: message
    });
    throw error;
  }
};

export const createLoad = (loadData) => async (dispatch) => {
  dispatch({ type: LOAD_ACTIONS.CREATE_LOAD_REQUEST });
  
  try {
    const response = await api.post('/inbound/loads', loadData);
    console.log('Load created:', response.data);
    
    dispatch({
      type: LOAD_ACTIONS.CREATE_LOAD_SUCCESS,
      payload: response.data
    });
    
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to create load';
    dispatch({
      type: LOAD_ACTIONS.CREATE_LOAD_FAILURE,
      payload: message
    });
    throw error;
  }
}; 